import { alpha } from '@mui/material/styles';
import { THEME_COLORS } from '../shared/constants/theme';
import { mobileAppGlassCard } from '../components/layout/mobile/mobileAppTheme';
import { getDashboardSectionContentPaperSx } from './dashboardSurfaceSx';
import { isMobileShellLayout } from './mobileShellLayout';

export function isDistributionMobileLayout() {
  return isMobileShellLayout();
}

/** Inner section Paper — transparent on mobile (outer Distribution shell provides glass). */
export function getDistributionSectionPaperSx(theme, isMobile = isDistributionMobileLayout()) {
  if (isMobile) {
    return {
      p: 0,
      bgcolor: 'transparent',
      background: 'none',
      border: 'none',
      borderRadius: 0,
      boxShadow: 'none',
    };
  }
  return {
    p: 4,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 2,
  };
}

export function getDistributionSectionHeaderRowSx(isMobile = isDistributionMobileLayout()) {
  return {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'stretch', md: 'center' },
    gap: { xs: 1.5, md: 0 },
    mb: { xs: 2, md: 3 },
  };
}

export function getDistributionSectionHeaderLeadSx(isMobile = isDistributionMobileLayout()) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 1.25, md: 2 },
    minWidth: 0,
  };
}

export function getDistributionSectionIconBoxSx(themeColor, isMobile = isDistributionMobileLayout()) {
  return {
    width: { xs: 44, md: 56 },
    height: { xs: 44, md: 56 },
    borderRadius: '12px',
    bgcolor: alpha(themeColor, 0.1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  };
}

export function getDistributionSectionIconFontSize(isMobile = isDistributionMobileLayout()) {
  return { xs: 26, md: 32 };
}

export function getDistributionSectionTitleSx(isMobile = isDistributionMobileLayout()) {
  return {
    fontWeight: 700,
    fontSize: { xs: '1.05rem', md: '1.5rem' },
    color: isMobile ? '#f8fafc' : 'text.primary',
    mb: 0.5,
  };
}

export function getDistributionSectionSubtitleSx(isMobile = isDistributionMobileLayout()) {
  return {
    color: isMobile ? 'rgba(148, 163, 184, 0.92)' : 'text.secondary',
    fontSize: { xs: '0.8rem', md: '0.875rem' },
    lineHeight: 1.45,
  };
}

export function getDistributionActionButtonSx(themeColor, isMobile = isDistributionMobileLayout()) {
  return {
    backgroundColor: themeColor,
    color: '#0a0f1a',
    fontWeight: 700,
    textTransform: 'none',
    width: { xs: '100%', md: 'auto' },
    py: { xs: 1, md: 0.75 },
    '&:hover': {
      backgroundColor: '#3ab89a',
    },
  };
}

export function getDistributionContentPaperSx(isDark, isMobile = isDistributionMobileLayout()) {
  return getDashboardSectionContentPaperSx(isDark, isMobile);
}

/** Embedded panel inside distribution section content. */
export function getDistributionEmbeddedPaperSx(isDark, isMobile = isDistributionMobileLayout()) {
  if (isMobile) {
    return {
      ...mobileAppGlassCard,
      p: { xs: 1.25, sm: 1.5 },
      bgcolor: 'transparent',
    };
  }
  return {
    p: 3,
    background: isDark
      ? `linear-gradient(165deg, ${THEME_COLORS.SURFACE_ELEVATED_DARK} 0%, ${THEME_COLORS.BACKGROUND_DARK} 100%)`
      : '#ffffff',
    border: `1px solid ${isDark ? alpha('#ffffff', 0.08) : '#e0e0e0'}`,
    borderRadius: 2,
    boxShadow: isDark ? 'inset 0 1px 0 rgba(255,255,255,0.04)' : 'none',
  };
}

export function getDistributionTableContainerSx(isMobile = isDistributionMobileLayout()) {
  return {
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: isMobile ? '12px' : 1,
    border: (theme) => `1px solid ${theme.palette.divider}`,
  };
}
